import { SkillForm } from "@/core/skillForms/types";
import { legalAdviceSkillStep1 } from "./step1";
import { legalAdviceSkillStep2 } from "./step2";

export const legalAdviceSkillForm: SkillForm = {
  skillId: "legal_advice",
  title: "Elaborar parecer jurídico",
  steps: [legalAdviceSkillStep1, legalAdviceSkillStep2],
};
